// extracted by mini-css-extract-plugin
module.exports = {"statsRow":"PlayerStats_statsRow__3V-as","placeholder":"PlayerStats_placeholder__2drRR"};